/**
 * Central DATX API Configuration
 * Connects frontend directly to the single source of truth (NestJS Backend & Admin Dashboard).
 */
export const isLocalhost = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' || 
  window.location.hostname === '127.0.0.1'
);

export const LIVE_API_URL = 'https://api.datxsci.com/api';
export const LOCAL_API_URL = 'http://localhost:5000/api';

export const API_BASE_URL = (
  isLocalhost 
    ? (process.env.REACT_APP_LOCAL_API_URL || LOCAL_API_URL)
    : (process.env.REACT_APP_API_URL || LIVE_API_URL)
).replace(/\/$/, '');

export default API_BASE_URL;
